import script from "./AppSettingsPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppSettingsPage.vue?vue&type=script&setup=true&lang=ts"

import "./AppSettingsPage.vue?vue&type=style&index=0&id=7e7b594e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7e7b594e"]])

export default __exports__